import { useState, useRef } from 'react';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useMatch, Link as RouterLink } from 'react-router-dom';
import NavigationButton from './NavigationButton';

const NavigationDropdown = ({ buttonKey, buttonLabel, menuItems }) => {
	const isActiveKey = `/${buttonKey}/:pattern`;
	const isActive = useMatch(isActiveKey);
	const { palette } = useTheme();
	const [open, setOpen] = useState(false);
	const anchorRef = useRef(null);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleButtonClick = () => {
		if (!open) handleOpen();
	};

	return (
		<Stack direction='row' spacing={2} sx={{ height: '100%', zIndex: 1 }}>
			<div onMouseLeave={handleClose}>
				<NavigationButton
					ref={anchorRef}
					activeKey={isActiveKey}
					id={`dropdown-button-${buttonKey}`}
					aria-controls={open ? 'dropdown-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-haspopup='true'
					onClick={handleButtonClick}
					onMouseEnter={handleOpen}
					endIcon={<KeyboardArrowDown fontSize='small' />}
				>
					{buttonLabel}
				</NavigationButton>
				<Popper
					open={open}
					anchorEl={anchorRef.current}
					placement='bottom-start'
					transition
					disablePortal
				>
					{({ TransitionProps }) => (
						<Grow
							{...TransitionProps}
							style={{
								transformOrigin: '0 0 0',
							}}
						>
							<Paper
								sx={{
									backgroundColor: palette.background.default,
								}}
								elevation={4}
							>
								<MenuList
									id='dropdown-menu'
									aria-labelledby={`dropdown-button-${buttonKey}`}
								>
									{menuItems.map(item =>
										item.isLegacy ? (
											<MenuItem
												key={item.key}
												component={Link}
												href={item.path}
												target='_self'
												rel='referrer'
												onClick={handleClose}
											>
												{item.label}
											</MenuItem>
										) : (
											<MenuItem
												key={item.key}
												onClick={handleClose}
												component={RouterLink}
												to={item.path}
												selected={
													isActive &&
													isActive.pathnameBase ===
														item.path
												}
											>
												{item.label}
											</MenuItem>
										)
									)}
								</MenuList>
							</Paper>
						</Grow>
					)}
				</Popper>
			</div>
		</Stack>
	);
};

NavigationDropdown.propTypes = {
	buttonKey: PropTypes.string.isRequired,
	buttonLabel: PropTypes.string.isRequired,
	menuItems: PropTypes.array.isRequired,
};

export default NavigationDropdown;
